import React, { useEffect, useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';

import { organisationsApi } from '../../../api/organisations';
import { FPOProvider } from './FPOContext';
import OnboardingForm from './OnboardingForm';

const NAV_ITEMS = [
  { to: '/app/dashboard', label: 'Overview' },
  { to: '/app/farmers', label: 'Farmers' },
  { to: '/app/listings', label: 'Listings' },
  { to: '/app/orders', label: 'Orders' },
];

function TabNav() {
  return (
    <nav className="-mb-px flex gap-6 overflow-x-auto whitespace-nowrap border-b border-gray-200">
      {NAV_ITEMS.map((item) => (
        <NavLink
          key={item.to}
          to={item.to}
          end={item.to === '/app/dashboard'}
          className={({ isActive }) =>
            `border-b-2 px-1 pb-3 text-sm font-medium transition-colors ${
              isActive
                ? 'border-green-700 text-green-800'
                : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700'
            }`
          }
        >
          {item.label}
        </NavLink>
      ))}
    </nav>
  );
}

export default function FPOLayout() {
  const [state, setState] = useState({ status: 'loading', organisation: null });

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const org = await organisationsApi.me();
        if (alive) setState({ status: 'ready', organisation: org });
      } catch (err) {
        if (!alive) return;
        if (err?.response?.status === 404) {
          setState({ status: 'needs_onboarding', organisation: null });
        } else {
          setState({ status: 'error', organisation: null });
        }
      }
    })();
    return () => {
      alive = false;
    };
  }, []);

  if (state.status === 'loading') {
    return <p className="text-sm text-gray-500">Loading your workspace…</p>;
  }

  if (state.status === 'error') {
    return (
      <p className="text-sm text-red-600">
        Couldn't reach the server. Make sure the backend is running on port 8000 and reload.
      </p>
    );
  }

  if (state.status === 'needs_onboarding') {
    return (
      <OnboardingForm
        onSuccess={(org) => setState({ status: 'ready', organisation: org })}
      />
    );
  }

  const setOrganisation = (org) => setState({ status: 'ready', organisation: org });

  return (
    <FPOProvider organisation={state.organisation} setOrganisation={setOrganisation}>
      <div className="flex flex-col gap-6">
        <TabNav />
        <Outlet />
      </div>
    </FPOProvider>
  );
}
